import Icon from "@material-ui/icons/Person";
import AddressCreate from "./AddressCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "studentAddresses",
  create: AddressCreate,
  icon: Icon,
};
